interface Props {
  label: string;
  selected?: boolean;
  onClick?: () => void;
}

export function Pill({ label, selected = false, onClick }: Props) {
  const cls = `pill ${selected ? 'pill--on' : ''}`;
  if (!onClick) return <span class={cls}>{label}</span>;
  return (
    <button type="button" class={cls} onClick={onClick}>
      {label}
    </button>
  );
}
